import React from 'react';
import type { FC } from 'react';
import { kebabCase } from 'lodash';
import { TextInput } from '@wix/cli-ui-kit';
import { useWizardStep } from '../Wizard.js';
import {
  createDashboardRouteValidation,
  useValidation,
} from '../../../dev-center/components/validations/index.js';
import { useWixCliAstroBi } from '../../../bi/index.js';
import { useProjectModel } from '../../../model.js';

export const TitleStep: FC<{
  pageTitle: string | undefined;
  onSubmit: (value: string) => void;
}> = ({ onSubmit, pageTitle }) => {
  const bi = useWixCliAstroBi();
  const { isActive, goToNextStep } = useWizardStep();

  return (
    <TextInput
      isActive={isActive}
      label={'Page title:'}
      placeholder={pageTitle ?? 'My Page'}
      onSubmit={(pageTitle) => {
        bi.cliFlowStepAnswered({
          question: 'Page title:',
          questionKey: 'generate_command.dashboard_page.choose_title',
          answer: pageTitle,
          additionalInfo: { extensionType: 'dashboard page' },
        });
        onSubmit(pageTitle);
        goToNextStep();
      }}
    />
  );
};

export const RouteStep: FC<{
  pageRoute: string | undefined;
  pageTitle: string | undefined;
  onSubmit: (value: string) => void;
}> = ({ pageRoute, pageTitle, onSubmit }) => {
  const { model } = useProjectModel();
  const bi = useWixCliAstroBi();
  const defaultPageRoute = kebabCase(pageTitle);
  const validateDashboardRoute = useValidation(
    createDashboardRouteValidation(model.projectFolder)
  );
  const { isActive, goToNextStep } = useWizardStep();

  return (
    <TextInput
      isActive={isActive}
      label={'Enter the route for the new page:'}
      placeholder={pageRoute ?? defaultPageRoute}
      onSubmit={(value) => {
        bi.cliFlowStepAnswered({
          question: 'Enter the route for the new page:',
          questionKey: 'generate_command.dashboard_page.choose_route',
          answer: value,
          additionalInfo: { extensionType: 'dashboard page' },
        });
        onSubmit(value);
        goToNextStep();
      }}
      validate={validateDashboardRoute}
    />
  );
};
